import gql from "graphql-tag";

import {
    IconDetailPartsFragmentDoc,
    PrepaidBalancePartsFragmentDoc
} from "icons/fragments";

export const GET_ICON_DETAIL_PAGE_DATA = gql`
    query iconDetailPageData($iconId: ID!) {
        iconDetail(iconId: $iconId) {
            ...IconDetailParts
            licenseDescription: license
            previewUrl
            attributionPreviewUrl
            countDownload
            createdAt
            uploadState
            tags {
                name
                slug
            }
            term {
                name
                slug
            }
            iconCollections {
                order
                collection {
                    name
                }
            }
        }

        moreLikeThisIcon(iconId: $iconId) {
            items {
                slugWithId
                thumbnail
                title
                id
            }
            url
            title
        }

        currentUser {
            id
            username
            hasSubscription
            ownedTeams {
                username
                name
            }
            ...PrepaidBalanceParts
        }

        latestIconPurchase(iconId: $iconId) {
            iconId
            purchaseDate
        }
    }
    ${IconDetailPartsFragmentDoc}
    ${PrepaidBalancePartsFragmentDoc}
`;
